import { useCallback } from 'react'

import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getTestStartTrigger } from 'services/Store/Project/triggers'
import { focusMain } from 'utils/accessibility'

import BaseButtonElement from '../BaseButtonElement'
import type { ButtonElementType } from '../buttonTypes'

interface IDefaultButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const StartButtonElement: React.FC<IDefaultButtonElementProps> = ({
  element,
  styles,
  mode,
  font,
  children,
}) => {
  const dispatch = useProjectDispatch()
  const trigger = useProjectContext(getTestStartTrigger)
  const label = element?.value?.label
  const onClick = useCallback(() => {
    if (!trigger.disabled) {
      dispatch(trigger.actionCreator())
      focusMain()
    }
  }, [dispatch, trigger])

  return (
    <BaseButtonElement
      action={element.value.action}
      disabled={trigger.disabled}
      elementId={element.id}
      font={font}
      label={label}
      mode={mode}
      onClick={onClick}
      styles={styles}
    >
      {children}
    </BaseButtonElement>
  )
}

export default StartButtonElement
